import { render, staticRenderFns } from "./01-C-resource-model.vue?vue&type=template&id=854e45d2&"
import script from "./01-C-resource-model.vue?vue&type=script&lang=js&"
export * from "./01-C-resource-model.vue?vue&type=script&lang=js&"
import style0 from "./01-C-resource-model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports